import { useState } from 'react'
import { Disclosure } from '@headlessui/react'
import { ChevronUp, ChevronDown } from 'lucide-react'
import { useCustomApi } from '@/contexts/CustomApiContext'
import { useLanguage } from '@/contexts/LanguageContext';
import LocalizedClientLink from '@/utils/LocalizedClientLink';

// Helper function to build the category hierarchy
const buildCategoryHierarchy = (categories) => {

  // First, find all top-level categories (those without a parent)
  const topLevelCategories = categories.filter(category => category?.category?.parent_category_id === null);
 
  // Create a map of categories by ID for quick lookup
  const categoryMap = {};
  categories.forEach(category => {
    categoryMap[category.category.id] = {
      ...category,
      children: []
    };
  });
  
  // Build the hierarchy
  categories.forEach(category => {
    if (category.category.parent_category_id && categoryMap[category.category.parent_category_id]) {
      categoryMap[category.category.parent_category_id].children.push(categoryMap[category.category.id]);
    }
  });
  
  // Return only the top-level categories with their children
  return topLevelCategories.map(category => categoryMap[category.category.id]);
};

export const MobileCategoryAccordion = () => {
  const { state } = useCustomApi();
  const { language } = useLanguage();
  const isRTL = language === "ar";
  const categories = state?.categories || [];
  const categoryHierarchy = buildCategoryHierarchy(categories);
  console.log(categoryHierarchy, "categoryHierarchy");
  
  const [openCategory, setOpenCategory] = useState(categoryHierarchy[0]?.category?.name || null);
  // Change to track selected subcategory
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  console.log(openCategory, "categoryHierarchy");

  // Toggle main category accordion
  const handleCategoryToggle = (categoryName) => {
    setOpenCategory(openCategory === categoryName ? null : categoryName);
    setSelectedSubcategory(null); // Reset selected subcategory when switching parent accordion
  };

  // Handle subcategory selection
  const handleSubcategoryToggle = (subcategoryId, subcategory) => {
    setSelectedSubcategory(subcategory);
  };

  // Recursive function to render subcategories
  const renderSubcategories = (subcategories, level = 0) => {
    if (!subcategories || subcategories.length === 0) return null;
    
    return (
      <div className={`pl-${level * 4} mt-2`}>
        {subcategories.map((subcategory, idx) => (
          <div key={idx} className="mb-2">
            {/* {subcategory.category_children && subcategory.category_children.length > 0 ? (
              <button
                onClick={() => handleSubcategoryToggle(subcategory.id, subcategory)}
                className="flex justify-between font-semibold transition-all duration-300 overflow-hidden  items-center w-full px-4 py-2 text-left font-primary tracking-wide font-medium text-sm"
              >
                {isRTL ? subcategory.metadata?.name_ar : subcategory.name}
              </button>
            ) : (
              <LocalizedClientLink href={`/${subcategory.handle}`}>
                <button
                  className="flex justify-between font-semibold transition-all duration-300 overflow-hidden  items-center w-full px-4 py-2 text-left font-primary tracking-wide font-medium text-sm"
                >
                  {isRTL ? subcategory.metadata?.name_ar : subcategory.name}
                </button>
              </LocalizedClientLink>
            )} */}

            {selectedSubcategory?.id === subcategory.id && subcategory.category_children && subcategory.category_children.length > 0 && (
              <div className="transition-all duration-300 overflow-hidden max-h-[1000px] opacity-100">
                <div className=" gap-1 px-4">
                  {subcategory.category_children.map((child, childIdx) => (
                    <div key={childIdx} className="relative">
                      {child.category_children && child.category_children.length > 0 ? (
                        <button
                          className="flex flex-row items-center w-full p-2"
                          onClick={() => handleSubcategoryToggle(child.id, child)}
                        >
                          <div className='w-auto h-auto p-2 bg-[#F5F5F5] rounded-[8px]'>
                            <img
                              src={child.metadata?.image || "/images/cst1.png"}
                              alt={child.name}
                              className="mix-blend-multiply w-[25px] h-[25px] object-cover mb-1 "
                            />
                          </div>
                          <span className="text-xs ml-2 font-medium text-center mt-1">{isRTL ? child.metadata?.name_ar : child.name}</span>
                        </button>
                      ) : (
                        <LocalizedClientLink href={`/shop?categories=${child.handle}`}>
                          <button className="flex flex-row items-center w-full p-2">
                            <div className='w-auto h-auto p-2 bg-[#F5F5F5] rounded-[8px]'>
                              {/* <img
                                src={child.metadata?.image || "/images/cst1.png"}
                                alt={child.name}
                                className="w-[25px] h-[25px] object-cover mb-1 "
                              /> */}
                            </div>
                            <span className="text-xs ml-2 font-medium text-center mt-1">{isRTL ? child.metadata?.name_ar : child.name}</span>
                          </button>
                        </LocalizedClientLink>
                      )}
                    </div>
                  ))}
                </div>
                {/* {renderSubcategories(subcategory.category_children, level + 1)} */}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="md:hidden py-10">
      {categoryHierarchy.map((category, idx) => (
        <div key={idx}>
          <button
            onClick={() => handleCategoryToggle(category.category.name)}
            className={`flex justify-between items-center w-full px-4 py-4 text-left bg-white font-primary tracking-wide font-semibold text-sm border ${
              openCategory === category.category.name ? 'border-b-0 rounded-b-none' : ''
            }`}
          >
            {isRTL ? category?.category?.metadata?.name_ar : category.category.name}
            {openCategory === category.category.name ? <ChevronUp /> : <ChevronDown />}
          </button>

          <div
            className={`transition-all duration-300 overflow-hidden ${
              openCategory === category.category.name ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-4 pb-4 pt-2">
              {/* Show grid of subcategories only if no subcategory is selected */}
            
                <div className="grid grid-cols-3 gap-1">
                  {category.category.category_children.map((item, i) => (
                    <div key={i} className="relative">
                      {/* <LocalizedClientLink  key={i} href={`/${item.handle}`}> */}
                      <button
                        className="flex flex-col items-center w-full p-2"
                        onClick={() => handleSubcategoryToggle(item.id, item)}
                      >
                        <div className='w-full h-auto p-2 bg-[#F5F5F5] rounded-[8px]'>
                          <img
                            src={item.metadata?.image || "/images/placeholder.png"}
                            alt={item.name}
                            className=" mix-blend-multiply w-[93px] h-[102px] object-cover mb-1"
                          />
                        </div>
                        <span className="text-xs font-medium text-center mt-1">{isRTL ?  item?.metadata?.name_ar : item?.name}</span>
                      </button>
                      {/* </LocalizedClientLink> */}
                    </div>
                  ))}
                </div>
        
              
              {/* Render subcategories recursively only for the selected subcategory */}
              {selectedSubcategory && selectedSubcategory.category_children && 
                renderSubcategories([selectedSubcategory], 0)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

